var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-footer",
    { staticStyle: { background: "#f9f9f9" }, attrs: { height: "204" } },
    [
      _c(
        "span",
        { attrs: { id: "help-fab" } },
        [
          !_vm.hideFab
            ? _c("SoliBtn", {
                staticClass: "shadow-orange-xl help-fab",
                attrs: {
                  icon: "question_mark",
                  round: "",
                  gradient: "gradient-orange",
                  fab: "",
                  right: "",
                  fixed: _vm.fixedFab,
                  bottom: _vm.fixedFab,
                  absolute: !_vm.fixedFab,
                  top: !_vm.fixedFab,
                },
                on: {
                  click: function ($event) {
                    _vm.showQuickContact = true
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showQuickContact
            ? _c("SoliResponsiveDialog", {
                attrs: { title: "Contact Us!" },
                on: {
                  reset: function ($event) {
                    _vm.closeModal(() => (_vm.showQuickContact = false))
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "body",
                      fn: function () {
                        return [
                          _c(
                            "v-card",
                            { staticClass: "soli-round", attrs: { flat: "" } },
                            [
                              _vm.guest
                                ? _c("SoliLocationExpandedContent", {
                                    staticClass: "mt-2",
                                    attrs: {
                                      location: _vm.guest.location,
                                      value: _vm.guest.location,
                                      icon: false,
                                    },
                                  })
                                : _c("SoliLocations", {
                                    attrs: {
                                      parentLocations: _vm.locations,
                                      showAddress: "",
                                      iterator: "",
                                      expandable: "",
                                    },
                                  }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2785746363
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "v-container",
        { staticClass: "justify-center safe-bottom", attrs: { fluid: "" } },
        [
          _c("v-col", [
            _c("div", { staticClass: "subtitle flex-col flex soli-grey" }, [
              _c(
                "a",
                {
                  staticClass: "mb-1",
                  attrs: { href: "https://musicologielessons.com" },
                },
                [
                  _c("jet-application-logo", {
                    staticClass: "block w-auto",
                    class: _vm.$vuetify.breakpoint.xs ? "h-6" : "h-9",
                  }),
                  _vm._v(" "),
                  _c("small", { staticClass: "soli-grey" }, [
                    _vm._v(
                      "\n                        Simply Delightful Music Lessons\n                    "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.$page.props.auth.user
                ? _c(
                    "a",
                    {
                      staticClass: "soli-round",
                      attrs: { color: "primary", href: "/" },
                    },
                    [_vm._v("\n                    Home")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "soli-round",
                  class: {
                    "accent--text": _vm.$page.url.includes("/privacy"),
                  },
                  attrs: { color: "primary", href: "/privacy" },
                },
                [_vm._v("\n                    Privacy Policy")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "soli-round",
                  class: {
                    "accent--text": _vm.$page.url.includes("/about"),
                  },
                  attrs: { color: "primary", href: "/about" },
                },
                [_vm._v("\n                    About MyMusicologie Software")]
              ),
              _vm._v(" "),
              !_vm.$page.props.auth.user
                ? _c(
                    "a",
                    {
                      staticClass: "soli-round",
                      class: {
                        "accent--text": _vm.$page.url.includes("/get-started"),
                      },
                      attrs: { color: "primary", href: "/get-started" },
                    },
                    [_vm._v("\n                    Get Started")]
                  )
                : _vm._e(),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }